import React from "react";
import Footer from "../components/Footer";

const AboutPage: React.FC = () => {
  const stemcafeWallImage = require("../assets/images/stemcafe-wall.jpg");
  const kidBackingWallImage = require("../assets/images/kid-backing-wall.jpg");
  const stemcafeCenter3Image = require("../assets/images/stemcafe-center-3.jpg");
  const kidsInCenter1Image = require("../assets/images/kids-in-center-1.jpg");
  const girlOnTableImage = require("../assets/images/girl-on-table.jpg");

  return (
    <div>
      <div id="about" className="p60">
        <div className="container">
          <div className="about-intro-wrap">
            <div className="about-header">
              <h2>About STEMCafe</h2>
              <p>
                STEMCafe is a non-linear learning centre where kids and young
                adults through play, explore the amazing world of STEM (Science,
                Technology, Engineering and Mathematics) through fun interactive
                activities for them to experiment with amazing creations and
                ideas that develops lifelong learning and interest in STEM.
              </p>
              <div className="avatar-illustration"></div>
            </div>
          </div>

          <div className="more-about">
            <p>
              STEMCafe is the first step towards creating an interactive
              experience where kids channel their energy, excitement, curiosity
              and creativity through play and by extension, expanding Africa's
              capacity and diversity of the STEM workforce pipeline to prepare
              the younger generation for the best jobs of the future that will
              see Africa become innovative, secure and competitive.
            </p>
          </div>

          <div className="window-flex">
            <div
              className="windows"
              style={{ backgroundImage: `url(${stemcafeWallImage})` }}
              aria-label="image 1"
            ></div>

            <div
              className="windows"
              style={{ backgroundImage: `url(${kidBackingWallImage})` }}
            ></div>

            <div
              className="windows"
              style={{ backgroundImage: `url(${stemcafeCenter3Image})` }}
            ></div>
          </div>

          <div className="more-about">
            <p>
              The space has a wide array of engaging activities for kids to
              tinker with including Digital labs, Coding challenges, Robotics
              kits, Prototyping with 3D printers, Physical computing with
              Arduino, Computer games, Child-friendly sci-fi movies/animations,
              Short videos on emerging technologies and many more.
            </p>
          </div>

          <div className="window-flex">
            <div
              className="windows"
              style={{ backgroundImage: `url(${kidsInCenter1Image})` }}
              aria-label="image 1"
            ></div>
            <div
              className="windows"
              style={{ backgroundImage: `url(${girlOnTableImage})` }}
            ></div>
          </div>
        </div>
      </div>

      <div className="container">
        <div className="contact-footer p60">
          <div>
            <h3>Contact</h3>
            <ul>
              <li>
                <i className="fas fa-map-marker-alt"></i>
                3rd Floor, 8 Montgomery Road, Sabo Yaba Lagos, Nigeria.
              </li>

              <li>
                <i className="fas fa-envelope"></i>
                <a href="mailto:info@stemcafe.io">info@stemcafe.io</a>
              </li>
            </ul>
          </div>
          <div className="hours">
            <h3>Opening hours</h3>
            <ul>
              <li>Weekdays: 10am - 5pm</li>
              <li>Saturday: 12am - 2pm</li>
            </ul>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default AboutPage;
